<template>
  <vz-select
    :modelValue="modelValue"
    big
    :label="$attrs.label || 'Терминал'"
    icon-variant="primary"
    icon-url="/svg/car/mini-loader.svg"
    placeholder="Введите терминал"
    :icon-size="16"
    :items="items"
    :required="required"
    :rules="rules"
    v-bind="$attrs"
  >
    <div v-if="useMap" class="vz-direction-map-btn" @click="showMapModal">
      <vz-icon
        name="map-marker"
        variant="primary"
        size="16"
      />
      <span class="fs-16" :class="{'color-inactive': $attrs.disabled}">На карте</span>
    </div>
    <div v-if="hasSchemeLink" class="vz-direction-scheme-link">
      <nuxt-link :to="schemeLink" target="_blank">
        Схема проезда
      </nuxt-link>
    </div>
    <slot />
  </vz-select>

  <client-only v-if="useMap">
    <vz-map-select-modal
      ref="mapSelectModal"
      :location="location"
      :terminal-guid="modelValue"
      :hide-switcher="!showSwitcher"
      :terminal-purpose="terminalPurpose"
      direction-type="terminal"
      @submit="onMapSubmit"
    />
  </client-only>
</template>

<script setup lang="ts">
import {Location, TerminalPurpose} from '~/types/types'
import {PropType} from 'vue'
import VzMapSelectModal from '~/components/modals/vz-map-select-modal.vue';
import {useTerminalStore} from "~/stores/terminal";
import VzSelect from '~/components/ui-kit/vz-select.vue';
import VzIcon from '~/components/ui-kit/vz-icon.vue';
import formRules from '~/common/vz-form-rules';

const emit = defineEmits(['map-submit'])

const props = defineProps({
  location: {
    type: Object as PropType<Location>,
    default: () => {}
  },
  modelValue: {
    type: String,
    default: ''
  },
  useMap: {
    type: Boolean,
    default: false
  },
  showSwitcher: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false,
  },
  purpose: {
    type: String as PropType<''|'from'|'to'|'requestOriginalDocuments'|'returnOfSupportingDocuments'>,
    default: ''
  },
  terminalPurpose: {
    type: String as PropType<''|TerminalPurpose>,
    default: ''
  },
  hasSchemeLink: {
    type: Boolean,
    default: false
  }
})

// Условно наследуем компонент от VzSelect
defineOptions({
  inheritAttrs: false
})

const {terminalSelectByLocation} = useTerminalStore()
const mapSelectModal = ref<typeof VzMapSelectModal>()

const items = computed(() => {
  return terminalSelectByLocation(props.location?.guid, props.purpose)
})

const rules = computed(() => {
  return !props.required ? [] : [formRules.required]
})

const schemeLink = computed(() => {
  return `/mapScheme?g=${props.modelValue}`
})

function showMapModal() {
  mapSelectModal.value?.show()
}

function onMapSubmit(data: any) {
  emit('map-submit', data)
}
</script>

<style scoped lang="scss">
.vz-direction {
  &-scheme-link {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;

    a {
      text-decoration: underline;
    }
  }
}
</style>